import React from 'react';
import ReactJsonView from '@microlink/react-json-view';
import { getRequest } from '@/services';

export default class JsonView extends React.Component {
  state = {
    json: {},
  };
  
  componentDidMount() {
    const { filePath } = this.props;
    if (filePath) {
      getRequest(filePath).then((json) => this.setState({ json }));
    }
  }

  render() {
    const { json } = this.state;

    return json ? (
      <ReactJsonView
        name={false}
        displayDataTypes={false}
        collapsed={1}
        src={json}
        {...this.props}
      />
    ) : (
      <p>Unsupported file type</p>
    );
  }
}
